import { Navigate } from 'react-router-dom';
import { useUserType } from '../hooks/useUserType';
import LoadingPage from './LoadingPage';

/**
 * Role-aware landing target for the bare `/settings` URL.
 *
 * After issue #2114 split Personal and Workspace settings into separate
 * top-level pages, `/settings` is the workspace-settings root:
 *
 * - Admins land on the Billing panel (`/settings/billing`) — the historical
 *   default that's been the admin "Settings" home since #1877.
 * - Signers have no workspace settings at all; they're sent to their own
 *   personal-settings home at `/account/profile`. The `<AdminRoute>` wrapper
 *   around `/settings/*` would catch a signer accessing any direct
 *   `/settings/<tab>` URL too, with the same `/account/profile` fallback.
 *
 * The redirect is rendered as an index element under the `/settings` route in
 * `App.tsx`; it never appears in its own right.
 */
export default function SettingsIndexRedirect() {
    const { isAdmin, loading } = useUserType();

    if (loading) {
        return <LoadingPage />;
    }

    if (isAdmin) {
        return <Navigate to="/settings/billing" replace />;
    }

    return <Navigate to="/account/profile" replace />;
}
